import ProductInlineBanner from '@/components/PIBanner';
import { useGlobal } from '@/utils/useGlobal';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import D from './components/D';
import D_AU from './components/D_AU';
import E from './components/E';
import F from './components/F';
import F_NA from './components/F_NA';
import G from './components/G';
import G_AU from './components/G_AU';
import H from './components/H';
import J from './components/J';
import J_AU from './components/J_AU';
import JoinUs from './components/JoinUs';
import K from './components/K';
import K_NA from './components/K_NA';
import L from './components/L';
import M from './components/M';
import N from './components/N';
import O from './components/O';
import Power from './components/Power';
import Thumb from './components/Thumb';

const HIDE_BLOG_SITE = ['eu', 'kr', 'nl'];

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('outdoorrecreation');
    const IS_NA = ['us', 'ca'].includes(locale);

    const obj: SideMenuProps = {
        items: IS_NA
            ? [
                  {
                      text: t('secC_card1_title'),
                      link: '#outdoor-recreation-D',
                  },
                  {
                      text: t('secC_card2_title'),
                      link: '#outdoor-recreation-J',
                  },
              ]
            : [
                  { text: t('secC_list1_title'), link: '#outdoor-recreation-G' },
                  { text: t('secC_list2_title'), link: '#outdoor-recreation-D' },
                  { text: t('secC_list3_title'), link: '#outdoor-recreation-J' },
              ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const entry_position: any = {
        us: 12,
        ca: 12,
        au: 11,
        za: 9,
    };

    return (
        <>
            <B />
            {IS_NA && (
                <>
                    <Thumb />
                    <Power />
                </>
            )}
            {!IS_NA && <C />}
            {['au'].includes(locale) && (
                <>
                    <G_AU />
                    <H />
                </>
            )}
            {['au'].includes(locale) ? <D_AU /> : <D />}
            <E />
            {IS_NA && <ProductInlineBanner />}
            {!['kr'].includes(locale) && <F />}
            {!['us', 'ca', 'au', 'za'].includes(locale) && (
                <>
                    <G />
                    <H />
                </>
            )}
            {['au'].includes(locale) ? <J_AU /> : <J />}
            {IS_NA ? <K_NA /> : <K />}
            {['au'].includes(locale) && <JoinUs />}
            {IS_NA && <F_NA />}
            <EmailSubscribe
                locale={locale}
                className="email-subscribe"
                pageType={PAGE_TYPE.OutdoorRecreation}
                entry_position={entry_position[locale] || entry_position['us']}
            />
            {!['kr'].includes(locale) && <L />}
            <M />
            {!HIDE_BLOG_SITE.includes(locale) && <N />}
            <O />
            <h2 className="annotation">{t('secP')}</h2>
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
        </>
    );
}
